import { memo } from 'react'
import { Box } from '@labrav/react-components'
import { Typography } from '@mui/material'
import { useStyles } from './ProductDetails.styles'
import { StatusChip } from './StatusChip/StatusChip'
import {
  ResellersInfo,
  Product,
  Status,
  Seller,
} from '../../../modules/cppoResellerAgreement/reducer'
import aws from '../../../common/images/aws.png'
import { useSelector } from '../../../store'
import { isEmpty } from 'lodash'

type ProductDetailsProps = {
  productName: string
  resellersInfo: ResellersInfo[]
  status: Status
  products: Product[]
} & Seller

export const ProductDetails = memo(() => {
  const { classes } = useStyles()
  const productDetailsValues = useSelector<Partial<ProductDetailsProps>>(
    ({ cppoResellerAgreement }) => ({
      products: cppoResellerAgreement.products,
      resellersInfo: cppoResellerAgreement.resellersInfo,
      status: cppoResellerAgreement.status,
      sellerName: cppoResellerAgreement.sellerName,
      sellerLogoUrl: cppoResellerAgreement.sellerLogoUrl,
    })
  )
  const { products, resellersInfo, status, sellerName, sellerLogoUrl } =
    productDetailsValues
  const reseller = resellersInfo && resellersInfo[0]
  const productName = products && products[0]?.productName

  if (
    isEmpty(productDetailsValues) ||
    Object.values(productDetailsValues).every(value => !value)
  ) {
    return <div></div>
  }
  return (
    <div className={classes.root}>
      <Box heading={'Product Details'} subHeading={''}>
        <div className={classes.productNameChip}>
          <div className={classes.productImageName}>
            <div className={classes.productImageContainer}>
              <img
                className={classes.productImage}
                src={aws}
                alt="aws"
                data-testid="aws-logo"
              />
            </div>
            <Typography className={classes.companyName}>
              {productName || 'N/A'}
            </Typography>
          </div>
          {status && (
            <div className={classes.chipWrapper}>
              <StatusChip status={status} />
            </div>
          )}
        </div>
        <div className={classes.agreementBetweenContainer}>
          <Typography className={classes.agreementBetween}>
            Agreement between
          </Typography>
          <div className={classes.isvResellerContainer}>
            <div className={classes.isvReseller}>
              <div className={classes.companyLogoTitle}>
                <div className={classes.sellerImageContainer}>
                  <img
                    className={classes.sellerImage}
                    src={sellerLogoUrl}
                    alt={sellerName || ''}
                  />
                </div>
                <div className={classes.agreementCompany}>
                  <Typography className={classes.agreementCompanyTitle}>
                    ISV
                  </Typography>
                  <Typography className={classes.agreementName}>
                    {sellerName}
                  </Typography>
                </div>
              </div>
              <div className={classes.companyLogoTitle}>
                <div className={classes.sellerImageContainer}>
                  <img
                    className={classes.sellerImage}
                    src={reseller?.resellerLogoUrl}
                    alt={
                      reseller?.resellerCompanyName ||
                      reseller?.companyName ||
                      ''
                    }
                  />
                </div>
                <div className={classes.agreementCompany}>
                  <Typography className={classes.agreementCompanyTitle}>
                    Reseller
                  </Typography>
                  <Typography className={classes.agreementName}>
                    {reseller?.resellerCompanyName || 'N/A'}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Box>
    </div>
  )
})
